// extracted by mini-css-extract-plugin
export default {"header":"PaginaPadrao_header__aR5W4","header__text":"PaginaPadrao_header__text__AJ-dq"};